
export default {
  name: 'BaseVideo',
  props: {
    blok: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    active: false
  }),
  computed: {
    videoUrl() {
      const url = new URL(this.blok.url?.url || this.blok.video?.filename)
      if (this.isVimeo && (this.blok.autoplay || this.blok.image)) {
        url.searchParams.set('autoplay', '1')
      }
      return url.toString()
    },
    isVimeo () {
      // https://player.vimeo.com/video/286898202?h=fd61acd044
      return (this.blok.url?.url || '').includes('vimeo.com')
    },
  },
  beforeMount () {
    if (!this.blok.image?.filename) {
      this.active = true
    }
  }
}
